import { ReactComponent as LogoSvg } from "./logo.svg";

export function Logo() {
  return <LogoSvg />;
}
